import {
    Box,
    Typography,
    Stack,
} from "@mui/material";
const OrgInfoSummary = ({users, pendingUserList, invoicesData}) => {

  const totalAvailableSeats = invoicesData?.reduce((total, invoice) => {
    const quantity = invoice?.product?.quantity || 0;
    const used = invoice?.product?.usedQuantity || 0;
    const available = quantity - used;
    return total + available;
  }, 0);

    return (
        <Stack direction="column" justifyContent="center" gap={2}>
        <Stack direction="row" gap={5} alignItems="center">
          <Box sx={{ flexBasis: "90%" }}>
            <Typography sx={{ fontWeight: "bold" }}>
              Available Seats
            </Typography>
          </Box>
          <Box sx={{ flexBasis: "10%" }}>
            <Box
              component="span"
              sx={{ fontSize: "25px", color: "#4A92DB" }}
            >
              {totalAvailableSeats || 0}
            </Box>
          </Box>
        </Stack>
        <Stack direction="row" gap={5} alignItems="center">
          <Box sx={{ flexBasis: "90%" }}>
            <Typography sx={{ fontWeight: "bold" }}>
              Organization Members
            </Typography>
          </Box>
          <Box sx={{ flexBasis: "10%" }}>
            <Box
              component="span"
              sx={{ fontSize: "25px", color: "#4A92DB" }}
            >
              {users?.length || 0}
            </Box>
          </Box>
        </Stack>
        <Stack direction="row" gap={5} alignItems="center">
          <Box sx={{ flexBasis: "90%" }}>
            <Typography sx={{ fontWeight: "bold" }}>
              Pending Invites
            </Typography>
          </Box>
          <Box sx={{ flexBasis: "10%" }}>
            <Box
              component="span"
              sx={{ fontSize: "25px", color: "#4A92DB" }}
            >
              {pendingUserList?.length || 0}
            </Box>
          </Box>
        </Stack>
      </Stack>
    );
};

export default OrgInfoSummary;